export type ProfileEditorConvRuntime = Record<string, unknown>;

function scopeKeyFor(slug: string, bundleID: string): string {
  return `__profileEditorConvId_${slug}-${bundleID}`;
}

export function getOrCreateProfileEditorConvID(args: {
  slug: string;
  bundleID: string;
  runtime?: ProfileEditorConvRuntime;
  generateUUID: () => string;
}): string {
  const { slug, bundleID, runtime, generateUUID } = args;
  if (!runtime) {
    return generateUUID();
  }

  const key = scopeKeyFor(slug, bundleID);
  const existing = runtime[key];
  if (typeof existing === 'string' && existing.trim() !== '') {
    return existing;
  }

  const fresh = generateUUID();
  runtime[key] = fresh;
  return fresh;
}
